import { render } from "./RealtimeUploadTotalDuration.vue?vue&type=template&id=00a9e326&ts=true"
import script from "./RealtimeUploadTotalDuration.vue?vue&type=script&lang=ts"
export * from "./RealtimeUploadTotalDuration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__